import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OtpValidationComponent } from '../otp-validation/otp-validation.component';

@Component({
  selector: 'app-verify-number-reminder-modal',
  templateUrl: './verify-number-reminder-modal.component.html',
  styleUrls: ['./verify-number-reminder-modal.component.scss']
})
export class VerifyNumberReminderModalComponent {
  phoneNumber?: string;
  cellphone?: string;
  documentId?: string;
  plate?: string | null;

  constructor(
    private dialogRef: MatDialogRef<VerifyNumberReminderModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  openOtpValidation(): void {
    this.dialogRef.close(false);
    this.dialog.open(OtpValidationComponent, {
      data: this.data
    });
  }

  closeModal(): void {
    this.dialogRef.close(false);
  }
}
